module.exports = __webpack_public_path__ + "img/guide.b967d9a3.png";